import React, { useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useSortQueryState } from '@features/JournalSortFilter/lib/hooks';

export const useEventsSort = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const { sortQueryValue, setSortQueryState } = useSortQueryState();

    const sortBtnRef = useRef<HTMLDivElement | null>(null);

    const handleToggleDropdown = () => setIsOpen(!isOpen);
    const handleCloseDropdown = () => setIsOpen(false);

    const handleFilterContainerClick = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        handleToggleDropdown();
    };

    return {
        t,
        handleCloseDropdown,
        handleFilterContainerClick,
        handleToggleDropdown,
        sortBtnRef,
        sortQueryValue,
        setSortQueryState,
        isOpen,
    };
};
